//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/manufacturers/views/main/lan/es';
import firmwareTab from 'Modules/manufacturers/.components/firmwareTab/lan/es';
import refreshFirmware from 'Modules/manufacturers/.components/refreshFirmware/lan/es';
import deletePartNumber from 'Modules/manufacturers/.components/partNumbersTab/.components/deletePartNumber/lan/es';
import partNumbersTab from 'Modules/manufacturers/.components/partNumbersTab/lan/es';
import createEditPartNumber from 'Modules/manufacturers/.components/partNumbersTab/.components/createEditPartNumber/lan/es';
import deviceModelsTab from 'Modules/manufacturers/.components/deviceModelsTab/lan/es';
import assignFirmware from 'Modules/manufacturers/.components/firmwareTab/.components/assignFirmware/lan/es';
import unitTypesTab from 'Modules/manufacturers/.components/unitTypesTab/lan/es';
import refreshDevicesConfig from 'Modules/manufacturers/.components/refreshDevicesConfig/lan/es';
import cannedCommandsTab from 'Modules/manufacturers/.components/cannedCommandsTab/lan/es';
import createEditCannedCommand from 'Modules/manufacturers/.components/cannedCommandsTab/.components/createEditCannedCommand/lan/es';
import deleteCannedCommand from 'Modules/manufacturers/.components/cannedCommandsTab/.components/deleteCannedCommand/lan/es';
import createEditUnitType from 'Modules/manufacturers/.components/unitTypesTab/.components/createEditUnitType/lan/es';
import deleteUnitType from 'Modules/manufacturers/.components/unitTypesTab/.components/deleteUnitType/lan/es';
import showUnitTypeEvents from 'Modules/manufacturers/.components/unitTypesTab/.components/showUnitTypeEvents/lan/es';
import createEditManufacturer from 'Modules/manufacturers/views/.components/createEditManufacturer/lan/es';
import deleteManufacturer from 'Modules/manufacturers/views/.components/deleteManufacturer/lan/es';
import createEditDeviceModel from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/lan/es';
import editAlertTypeSupported from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/editAlertTypeSupported/lan/es';
import bulkAssignAlertTypes from 'Modules/manufacturers/.components/deviceModelsTab/.components/bulkAssignAlertTypes/lan/es';
import syncCTCInformation from 'Modules/manufacturers/views/.components/syncCTCInformation/lan/es';

locales = {
    ...locales,
    ...main,
    ...firmwareTab,
    ...refreshFirmware,
    ...deletePartNumber,
    ...partNumbersTab,
    ...createEditPartNumber,
    ...deviceModelsTab,
    ...assignFirmware,
    ...unitTypesTab,
    ...refreshDevicesConfig,
    ...cannedCommandsTab,
    ...createEditCannedCommand,
    ...deleteCannedCommand,
    ...createEditUnitType,
    ...deleteUnitType,
    ...showUnitTypeEvents,
    ...createEditManufacturer,
    ...deleteManufacturer,
    ...createEditDeviceModel,
    ...editAlertTypeSupported,
    ...bulkAssignAlertTypes,
    ...syncCTCInformation,
};


export default locales;